import { all, call } from 'redux-saga/effects';

import { userSagas } from './user/user.sagas';

export default function* rootSaga() {
  // Initializes each saga on separate task streams instead of yielding each one
  yield all([
    call(userSagas),
  ]);
};